import React, { useEffect, useState } from 'react'
import { AddUpdate } from '../../../ApiMethods/ApiMethods'
import DataTable from 'react-data-table-component'
import { customStyles } from '../Utility/Utility'
import Loader from '../Loader/Loader';
import { Modal } from 'react-bootstrap'
import swal from 'sweetalert2';
import Swal from 'sweetalert2';

const AstrologerGiftCard = () => {
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(false)
  const [modalOpen, setModalOpen] = useState(false)
  const [giftcardid, setGiftCardId] = useState("")
  const [addFormData, setAddFormData] = useState({
    GiftCardCode: "",
    Amount: "",
    File: ""

  })


  const getdata = async () => {

    try {
      setLoading(true)
      const postdata = { IsActive: "1" }
      const res = await AddUpdate("GiftCards/GetData_GiftCards", postdata)

      if (res?.data?.data) {
        let datas = JSON.parse(res?.data?.data)
        let data = datas?.Table;
        setData(data)

      }

    } catch (error) {
      console.log(error, "error")
    }
    finally {
      setLoading(false)
    }

  }
  useEffect(() => {
    getdata()
  }, [])
  const Resetform = () => {
    setAddFormData({
      GiftCardCode: "",
      Amount: "",
      File: ""
    })
  }

  const handlechange = (e) => {
    const { name, type, value, files } = e.target;

    setAddFormData((prev) => ({
      ...prev,
      [name]: type === "file" ? files[0] : value,
    }));
  };


  const handleDelete = async (GiftCardId) => {
    try {
      swal.fire({
        title: 'Are you sure?',
        text: "You want to delete this gift card ?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then(async (result) => {
        if (result.isConfirmed) {
          setLoading(true)
          const postdata = { GiftCardId: GiftCardId }
          const res = await AddUpdate("GiftCards/Delete_GiftCards", postdata)


          getdata()
        }
      })
    } catch (error) {
      console.log(error, "error")
    }
    finally {
      setLoading(false)
    }
  }

  const openEditModal = (row) => {

    setGiftCardId(row.GiftCardId)
    setAddFormData({
      GiftCardCode: row.GiftCardCode,
      Amount: row.Amount,
      File: row.File
    })
    setModalOpen(true)
  }



  const columns = [
    { name: 'ID', selector: row => row.GiftCardId, sortable: true, width: '100px' },
    { name: 'GiftCard Code', selector: row => row.GiftCardCode, sortable: true, },
    { name: 'Amount', selector: row => row.Amount, sortable: true },
    { name: 'IsActive', selector: row => row.IsActive ? "Active" : "Inactive", sortable: true },
    {
      name: "Action",
      cell: row => (
        <>
          <button
            className="btn btn-sm btn-warning m-1"
            onClick={() => openEditModal(row)}
          >
            Edit
          </button>

          <button
            className="btn btn-sm btn-danger"
            onClick={() => handleDelete(row.GiftCardId)}
          >
            Delete
          </button>

        </>
      )
    }

  ]

  const openModal = () => {

    setGiftCardId("")
    Resetform()
    setModalOpen(true)
  }
  const submitdata = async () => {
    if (!addFormData.GiftCardCode || !addFormData.Amount) {
      Swal.fire({
        title: "Required Fields Missing",
        text: "Please enter Gift Card Code and Amount",
        icon: "warning",
        confirmButtonText: "OK",
      });
      return;
    }


    try {
      setLoading(true)
      const formData = new FormData();

      if (!giftcardid) {

        const postdata = { GiftCardCode: addFormData.GiftCardCode, Amount: addFormData.Amount }

        formData.append('Data', JSON.stringify(postdata));
        formData.append('File', addFormData.File);

        const res = await AddUpdate("GiftCards/Insert_GiftCards", formData)
      } else {

        const postdata = { GiftCardCode: addFormData.GiftCardCode, Amount: addFormData.Amount, GiftCardId: giftcardid }
        formData.append('Data', JSON.stringify(postdata));
        formData.append('File', addFormData.File);

        const res = await AddUpdate("GiftCards/Update_GiftCards", formData)
      }

      setModalOpen(false)
      getdata()
    } catch (error) {
      console.log(error, "error")
    }
    finally {
      setLoading(false)
    }
  }

  return (
    <>

      <div className="d-flex justify-content-between align-items-center mb-2">
        <h2 style={{ color: '#f7931e', fontWeight: 700 }}>
          Astrologer Gift Cards
        </h2>

        <button
          onClick={openModal}
          className="btn btn-primary"
        >
          Add Gift Card
        </button>
      </div>




      <div className="col-12 mt-2">


        {loading ? (
          <Loader />
        ) : (
          <DataTable
            dense
            data={data || []}
            columns={columns}
            selectableRowsHighlight
            pagination
            persistTableHead={true}
            noDataComponent={"There are no data to display"}
            customStyles={customStyles}
          />)}
      </div>


      <div className="mb-sm-3 d-flex flex-wrap align-items-center text-head mb-1">

        <Modal
          className="modal fade"
          show={modalOpen}
          onHide={() => setModalOpen(false)}
          backdrop="static"
        >
          <form>
            <div className="modal-header">
              <h4 className="modal-title fs-20">
                {giftcardid ? "Edit Gift Card Details" : "Add Gift Card Details"}
              </h4>
              <button
                type="button"
                className="btn-close"
                onClick={() => setModalOpen(false)}
                data-dismiss="modal"
              ></button>
            </div>
            <div className="modal-body p-3">
              <i
                className="flaticon-cancel-12 close"
                data-dismiss="modal"
              ></i>
              <div className="add-contact-box">
                <div className="add-contact-content">
                  <div className="form-group">
                    <label htmlFor="">GiftCard code
                      <span className="text-danger star-error">
                        *
                      </span></label>
                    <input
                      type="text"
                      autoComplete="off"
                      name="GiftCardCode"
                      required="required"
                      value={addFormData?.GiftCardCode}
                      onChange={handlechange}
                    />
                  </div>
                </div>
              </div>

              <div className="add-contact-box">
                <div className="add-contact-content">
                  <div className="form-group">
                    <label htmlFor="">Amount
                      <span className="text-danger star-error">
                        *
                      </span></label>
                    <input
                      type="number"

                      autoComplete="off"
                      name="Amount"
                      required="required"
                      value={addFormData?.Amount}
                      onChange={handlechange}
                    />
                  </div>
                </div>
              </div>

              <div className="add-contact-box">
                <div className="add-contact-content">
                  <div className="form-group">
                    <label htmlFor="">Choose File
                    </label>
                    <input
                      type="file"
                      name="File"
                      onChange={handlechange}
                    />

                  </div>
                </div>
              </div>


            </div>
            <div className="modal-footer">


              {giftcardid ? (
                <button
                  type='button'
                  className="btn btn-primary"
                  onClick={submitdata}
                >
                  Update
                </button>
              ) : (

                <button
                  type='button'
                  className="btn btn-primary"
                  onClick={submitdata}
                >
                  Save
                </button>

              )}

              <button
                type="button"
                onClick={() => {
                  setModalOpen(false);

                }}
                className="btn btn-danger"
              >
                <i className="flaticon-delete-1"></i> Close
              </button>
            </div>
          </form>
        </Modal>
      </div>

    </>

  )
}

export default AstrologerGiftCard